import { useConsent } from "@newsela/snitch";

import {
  DATAGRAIL_LOADER_URL,
  DATAGRAIL_PERFORMANCE_CATEGORY,
} from "@/datagrailIntegration/config";
import useUser from "@/users/useUser/useUser";

/**
 * Whether the event stream may send every dimension property.
 *
 * Students are always granted. useStudentConsentSuppression turns their
 * DataGrail performance consent off to keep Pendo away, but we still want
 * their first-party event stream data (USMAN-5742).
 *
 * The student check reads useUser rather than useGetUserProperties, which
 * only resolves after an effect. On pages that server-render the user this
 * covers the first page view. On other pages, events fired before /me
 * resolves follow the student's stored DataGrail consent. For a returning
 * student that is the essential-only state useStudentConsentSuppression
 * saved, so those first events are stripped. We accept that rather than
 * granting consent while the user loads, which would send full payloads for
 * users who declined.
 *
 * Without DataGrail configured there is nothing to respect, so events stay
 * as they were before consent existed.
 */
const useEventStreamConsent = (): boolean => {
  const hasPerformanceConsent = useConsent(DATAGRAIL_PERFORMANCE_CATEGORY);
  const { data: user } = useUser();
  const isStudent = user?.student?.id !== undefined;

  if (!DATAGRAIL_LOADER_URL || isStudent) {
    return true;
  }

  return hasPerformanceConsent;
};

export default useEventStreamConsent;
